import { placeholder } from '@webapp/common/lib/ui';
import type { LogicTransitionVariant } from '@webapp/common/resources/survey';
import {
    LinkParamsLogicType,
    LogicAction,
    LogicBoolFunc,
    LogicTransition,
    LogicTransitionType,
    LogicType,
} from '@webapp/common/resources/survey';

export enum LogicSubConditonType {
    QUESTION = 0,
    LINK_PARAM = 1,
}

export const initialLogicSubCondition: LogicSubCondition = {
    type: LogicSubConditonType.QUESTION,
    boolFunc: LogicBoolFunc.OR,
    id: 0,
    logicId: 0,
    responsesCount: 0,
    respondent: LogicType.SELECT_VARIANTS,
    variants: [],
};

export interface LogicSubCondition {
    type: LogicSubConditonType;
    boolFunc: LogicBoolFunc;
    boolFuncExternal?: LogicBoolFunc;
    id: number;
    logicId: number;
    questionId?: number;
    linkParamId?: number;
    linkParamValue?: string;
    responsesCount: number;
    respondent: LogicType;
    variants: Array<Partial<LogicVariant>>;
    minCount?: number;
    maxCount?: number;
}

export interface LogicCondition {
    fetch: boolean;
    expand: boolean;
    id: number;
    respondent: LogicType;
    isExtended?: boolean;
    action: LogicAction;
    transition: LogicTransition;
    transitionType: LogicTransitionType;
    boolFunc: LogicBoolFunc;
    boolFuncExternal?: LogicBoolFunc;
    toQuestion: number;
    toQuestions: Array<number>;
    toPages: Array<number>;
    toSurvey: number;
    toPage: number;
    toWebsite: string;
    completeText: string;
    disqualText: string;
    variants: Array<LogicVariant>;
    linkParamId?: number;
    linkParamValue?: string;
    responsesCount: number;
    conditions: Array<LogicSubCondition>;
    linkParamsLogicType: LinkParamsLogicType;
    answersToHide: Array<number>;
    minCount?: number;
    maxCount?: number;
    finishTransition?: LogicTransition;
    afterQuestionId?: number;
    finishTransitionVariant?: LogicTransitionVariant;
    copyUrlParams?: boolean;
}

export type LogicConditionParamName = keyof Omit<LogicCondition, 'fetch' | 'expand' | 'id'>;

// TODO use in editor only. store only checked ids
export interface LogicVariant {
    id: number | string;
    name: string;
    checked: boolean;
    order: number;
}

export const initialLogicVariant: Readonly<LogicVariant> = {
    id: 0,
    name: '',
    checked: false,
    order: 0,
};
export const initialLogicCondition: Readonly<LogicCondition> = {
    fetch: false,
    expand: false,
    id: 0,
    respondent: LogicType.ALWAYS,
    linkParamsLogicType: LinkParamsLogicType.EQUAL,
    action: LogicAction.SHOW,
    transition: LogicTransition.QUESTION,
    transitionType: LogicTransitionType.TEXT,
    boolFunc: LogicBoolFunc.OR,
    toQuestion: null,
    toQuestions: [],
    toPages: [],
    answersToHide: [],
    toSurvey: null,
    toWebsite: null,
    responsesCount: 0,
    toPage: null,
    completeText: null,
    disqualText: placeholder(
        'Приносим свои извинения, но для опроса требуется иная целевая аудитория. Благодарим вас за готовность принять участие!',
    ),
    variants: [],
    conditions: [],
};
